<template>
    <div>
<!--        <breadcrumb :routerList="[{title:'OEM付款报表 '}]"/>-->
      <Breadtabsheader/>
		<div class="h-content" style="">
            <!-- tab切换 -->
            <div class=" ">
            <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
                <el-tab-pane label="生成随货单" name="first" :key="'first'">
                <creation-info v-if="isFirst" />
                </el-tab-pane>
                <el-tab-pane label="打印随货单" name="second" :key="'second'">
                <un-creation-info v-if="isSecond" />
                </el-tab-pane>
            </el-tabs>
            </div>
		</div>
    </div>
</template>
<script>
    import CreationInfo from './addNewProductTabCom/creationInfo'
    import UnCreationInfo from './addNewProductTabCom/unCreationInfo'
    export default {
        components: {
            //Breadcrumb,
            CreationInfo,UnCreationInfo
        },
        data() {
            return {
                // 默认第一个Tab
                activeName: "first",
                isFirst: true,
                isSecond: false,
            };

        },
        methods: {
            //tab切换
            handleClick(tab) {
            if (tab.name === "first") {
                this.isFirst = true;
                this.isSecond = false;
            } else if (tab.name === "second") {
                this.isFirst = false;
                this.isSecond = true;
            }
            },
            
        }
    }
</script>
<style scoped>
    .h-content{
        background: #fff
    }
</style>